import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./ErrorScreen.module.scss";
import { LogoSvg } from "@/frontend/shared/assets/LogoSvg";
import { NormalButton } from "../Button";

export function ErrorScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <LogoSvg className={styles.logo} />
      </div>
      <div className={styles.contentContainer}>
        <Typography color="greyscale100" variant="heading-6" className={styles.headline}>
          Whoops! That didn’t work.
        </Typography>
        <Typography color="greyscale300" variant="body-2" className={styles.description}>
          Our bad! Something went wrong. Try refreshing the page in a few moments.
        </Typography>
        <NormalButton
          onClick={() => window.location.reload()}
          size="large"
          variant="primary"
          className={styles.refreshButton}
        >
          Refresh page
        </NormalButton>
      </div>
    </div>
  );
}
